/* Ruth Journal interactions */
(function () {
    const root = document.documentElement;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Nav: condensed state on scroll */
    const nav = document.getElementById('r-nav');
    const onScroll = function () {
        if (nav) nav.classList.toggle('is-scrolled', window.scrollY > 8);
    };

    /* Reading progress */
    const bar = document.querySelector('.r-progress span');
    const article = document.querySelector('.r-prose');
    const progress = function () {
        if (!bar || !article) return;
        const rect = article.getBoundingClientRect();
        const total = rect.height - window.innerHeight * 0.6;
        const done = Math.min(Math.max(-rect.top + window.innerHeight * 0.2, 0), total);
        bar.style.transform = 'scaleX(' + (total > 0 ? done / total : 0) + ')';
    };

    let ticking = false;
    window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
            onScroll();
            progress();
            ticking = false;
        });
    }, {passive: true});
    onScroll();
    progress();

    /* Mobile sheet */
    const burger = document.querySelector('.r-burger');
    if (burger) {
        const toggle = function (open) {
            root.classList.toggle('r-menu-open', open);
            burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        };
        burger.addEventListener('click', function () {
            toggle(!root.classList.contains('r-menu-open'));
        });
        document.querySelectorAll('.r-sheet a').forEach(function (a) {
            a.addEventListener('click', function () { toggle(false); });
        });
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') toggle(false);
        });
        window.matchMedia('(min-width: 900px)').addEventListener('change', function (e) {
            if (e.matches) toggle(false);
        });
    }

    /* Scroll reveal */
    const io = (!reduce && 'IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
        });
    }, {rootMargin: '0px 0px -8% 0px', threshold: 0.08}) : null;

    const reveal = function (scope) {
        const items = (scope || document).querySelectorAll('[data-reveal]:not(.is-in)');
        const groups = new Map();
        items.forEach(function (el) {
            const parent = el.parentElement;
            const i = groups.get(parent) || 0;
            groups.set(parent, i + 1);
            el.style.setProperty('--d', Math.min(i, 5) * 70 + 'ms');
            if (io) io.observe(el); else el.classList.add('is-in');
        });
    };
    reveal();

    /* Load more */
    const more = document.querySelector('[data-load-more]');
    const feed = document.querySelector('[data-feed]');
    if (more && feed) {
        more.addEventListener('click', async function (e) {
            e.preventDefault();
            if (more.classList.contains('is-loading')) return;
            more.classList.add('is-loading');
            try {
                const res = await fetch(more.href);
                const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
                const cards = doc.querySelectorAll('[data-feed] > *');
                const frag = document.createDocumentFragment();
                cards.forEach(function (card) { frag.appendChild(document.importNode(card, true)); });
                feed.appendChild(frag);
                reveal(feed);
                const next = doc.querySelector('[data-load-more]');
                if (next) {
                    more.href = next.href;
                    more.classList.remove('is-loading');
                } else {
                    more.parentElement.remove();
                }
            } catch (err) {
                window.location.href = more.href;
            }
        });
    }

    /* Copy link */
    document.querySelectorAll('[data-copy]').forEach(function (btn) {
        btn.addEventListener('click', async function () {
            const url = btn.getAttribute('data-copy');
            try {
                if (navigator.share && window.matchMedia('(pointer: coarse)').matches) {
                    await navigator.share({title: document.title, url: url});
                    return;
                }
                await navigator.clipboard.writeText(url);
                btn.classList.add('is-copied');
                setTimeout(function () { btn.classList.remove('is-copied'); }, 1600);
            } catch (err) { /* user dismissed */ }
        });
    });
})();
